import { render, staticRenderFns } from "./ChangeEmailCompleteModule.vue?vue&type=template&id=b2a26320&scoped=true&"
import script from "./ChangeEmailCompleteModule.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailCompleteModule.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmailCompleteModule.vue?vue&type=style&index=0&id=b2a26320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a26320",
  null
  
)

export default component.exports